import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

// Styles
import styles from "./info-box.module.scss";

function InfoBox({ children, className }) {
  return (
    <div className={classnames(styles["info-box"], className)} data-test="info-box">
      {children}
    </div>
  );
}

InfoBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

InfoBox.defaultProps = {
  className: undefined,
};

export default InfoBox;
